import {useGetSurveyQuery} from "../../apis/surveyApi";
import StandardsGuidelinesAssessmentPage from "./StandardsGuidelines/StandardsGuidelinesAssessmentPage";

const MCAPPage = ({type}) => {
    const {data, isLoading} = useGetSurveyQuery(type);

    if(isLoading) return (<></>);

    switch(type) {
            case "StandardsGuidelines":   
                return (<StandardsGuidelinesAssessmentPage editObject={data} />); 
            default: return (<></>);
    }
}

export default MCAPPage;
